/* tslint:disable */
/* eslint-disable */
/**
 * True one Services API
 * True one service for form Builder
 *
 * The version of the OpenAPI document: 4.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues, parseDate, parseDateTime, serializeDate, serializeDateTime } from '../runtime';
import type { MachineChecklistCategory } from './MachineChecklistCategory';
import {
    MachineChecklistCategoryFromJSON,
    MachineChecklistCategoryFromJSONTyped,
    MachineChecklistCategoryToJSON,
    MachineChecklistCategoryToJSONTyped,
} from './MachineChecklistCategory';

/**
 * 
 * @export
 * @interface ChecklistTemplate
 */
export interface ChecklistTemplate {
    /**
     * 
     */
    id?: string;
    /**
     * 
     */
    type?: string;
    /**
     * 
     */
    name?: string;
    /**
     * 
     */
    description?: string;
    /**
     * 
     */
    machineId?: string;
    /**
     * 
     */
    generalWarningIds?: Array<string>;
    /**
     * 
     */
    activeVersionId?: string;
    /**
     * 
     */
    disabled?: boolean;
    /**
     * 
     */
    category?: MachineChecklistCategory;
    /**
     * 
     */
    createdAt?: Date;
    /**
     * 
     */
    updatedAt?: Date;
    /**
     * 
     */
    publishedAt?: Date;
}

/**
 * Check if a given object implements the ChecklistTemplate interface.
 */
export function instanceOfChecklistTemplate(value: object): value is ChecklistTemplate {
    return true;
}

export function ChecklistTemplateFromJSON(json: any): ChecklistTemplate {
    return ChecklistTemplateFromJSONTyped(json, false);
}

export function ChecklistTemplateFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChecklistTemplate {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'type': json['type'] == null ? undefined : json['type'],
        'name': json['name'] == null ? undefined : json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'machineId': json['machineId'] == null ? undefined : json['machineId'],
        'generalWarningIds': json['generalWarningIds'] == null ? undefined : json['generalWarningIds'],
        'activeVersionId': json['activeVersionId'] == null ? undefined : json['activeVersionId'],
        'disabled': json['disabled'] == null ? undefined : json['disabled'],
        'category': json['category'] == null ? undefined : MachineChecklistCategoryFromJSON(json['category']),
        'createdAt': json['createdAt'] == null ? undefined : (parseDateTime(json['createdAt'])),
        'updatedAt': json['updatedAt'] == null ? undefined : (parseDateTime(json['updatedAt'])),
        'publishedAt': json['publishedAt'] == null ? undefined : (parseDateTime(json['publishedAt'])),
    };
}

export function ChecklistTemplateToJSON(json: any): ChecklistTemplate {
    return ChecklistTemplateToJSONTyped(json, false);
}

export function ChecklistTemplateToJSONTyped(value?: ChecklistTemplate | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'type': value['type'],
        'name': value['name'],
        'description': value['description'],
        'machineId': value['machineId'],
        'generalWarningIds': value['generalWarningIds'],
        'activeVersionId': value['activeVersionId'],
        'disabled': value['disabled'],
        'category': MachineChecklistCategoryToJSON(value['category']),
        'createdAt': value['createdAt'] == null ? value['createdAt'] : serializeDateTime(value['createdAt']),
        'updatedAt': value['updatedAt'] == null ? value['updatedAt'] : serializeDateTime(value['updatedAt']),
        'publishedAt': value['publishedAt'] == null ? value['publishedAt'] : serializeDateTime(value['publishedAt']),
    };
}

